<template>
  <div class="app-container">
    <list ref="list">
      <template slot="toolbar-right" v-if="$permission.canWrite()">
          <!-- <el-button
          size="mini"
          type="primary"
          @click="create"
          icon="el-icon-plus"
          >添加</el-button
        > -->
        <!-- <el-button
          size="mini"
          class="filter-item"
          type="danger"
          @click="delRows"
          >删除</el-button
        > -->
      </template>
      <template slot="column" v-if="$permission.canWrite()">
        <!-- <el-table-column label="操作" fixed="right" align="center" width="80">
          <template slot-scope="{ row }">
            <el-button
          size="mini"
          type="primary"
          @click="create"
          icon="el-icon-plus"
          >中止</el-button
        >
          </template>
        </el-table-column> -->
        <!-- <el-table-column label="操作" fixed="right" align="center" width="120">
          <template slot-scope="{ row }">
            <el-button type="text" @click="editById(row.OrderId)">编辑</el-button>
            <el-button type="text" @click="delRows(row.OrderId)">删除</el-button>
          </template>
        </el-table-column> -->
      </template>
    </list>
    <!-- <edit-dialog ref="editDialog" @close-saved="reload" /> -->
  </div>
</template>
<script>
import curdMixins from "@/mixins/curd";
import list from "@/components/sales/report/saordersummary/list";
// import editDialog from "@/components/sales/report/sumtable/editDialog";

export default {
  name: "comment",
  mixins: [curdMixins],
  components: {
    list,
    // editDialog,
  },
  data() {
    return {
      api: require("@/api/sale/sales").default,
    }
  },
  methods: {
    // delRows(id) {
    // this.$confirm("确认删除数据吗？", "提示", {
    //   confirmButtonText: "确定",
    //   cancelButtonText: "取消",
    //   type: "warning",
    // })
    //   .then(() => {
    //     this.api.delete(id).then(res => {
    //       if(res.Code ==0) {
    //         this.$message.success("删除成功")
    //         this.$refs.list.reload();
    //       } else {
    //         this.$message.error(res.Msg)
    //       }
    //     })
    //   })
    //   .catch(() => {});
    // },
  },
};
</script>